/** Offer routes. */
import { OffersListPage } from "./OfferList.js";
import { OfferNewPage } from "./OfferNew.js";
import { OfferDetailPage } from "./OfferDetail.js";

export const offersRoutes = [
  { path: "offers", element: <OffersListPage /> },
  { path: "offers/new", element: <OfferNewPage /> },
  { path: "offers/:id", element: <OfferDetailPage /> },
];
